module.exports = __webpack_public_path__ + "static/media/p2008fener.f0e461df.jpg";